import { EMPTY_CREDIT_NOTE_DETAIL_ENTITY } from "domain/entity/CreditNote/CreditNoteDetailEntity";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import { CreditNoteConstant, creditNoteDtlRequiredFieldList } from "presentation/constant/CreditNote/CreditNoteConstant";
import { vatPaymentReferenceDateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useCreditNoteDetailVM } from "presentation/hook/CreditNote/useCreditNoteDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const CreditNoteDetailFormPanel = () => {
    const [creditNoteDetailState] = useCreditNoteDetailTracked();
    const creditNoteDetailVM = useCreditNoteDetailVM();
    const messageBarVM = useMessageBarVM();
    const CREDIT_NOTE_CONSTANT = CreditNoteConstant.Detail;
    const [isLoading, setIsLoading] = useState(false);
    // const [initScreen, setInitScreen] = useState(true);
    const { currentCreditNoteDtl, isAdd, isEditable, isRead, isSaveClicked, allFormState, editingHeader, isByManual, isByInvoice, isNormal } = creditNoteDetailState.creditNoteDetailState;
    const currentCreditNoteHdr = (isRead && isNormal) ? creditNoteDetailState.currentCreditNoteHdr : editingHeader;
    const { tariffDescMap, creditNoteDetails, selectedcreditNoteDetailRows, dynamicOptions, isExistLimit } = creditNoteDetailState;
    const [anaInfoState] = useANAInfoTracked();
    const countryCode: string = getDefaultBuConfig<string>("REACT_APP_DEFAULT_COUNTRY") || "PAK";
    const companyCode = anaInfoState.defaultOperatingCompany ?? "";//= "2691";
    const isReadOnly = (!!currentCreditNoteDtl.invoiceNo);
    const { operatingUnit } = anaInfoState;

    const handleCancelClick = useCallback(() => {
        creditNoteDetailVM.onCancelClick();
    }, [creditNoteDetailVM])

    const creditNoteNatureOptions = useCallback(() => {
        if (currentCreditNoteDtl.adjType === "Adjustment") {
            return dynamicOptions.adjNatureDropdownOptions;
        } else if (currentCreditNoteDtl.adjType === "Cancel Only") {
            return dynamicOptions.cancelOnlyNatureDropdownOptions;
        } else if (currentCreditNoteDtl.adjType === "Cancel & Re-bill") {
            return dynamicOptions.cancelRebillNatureDropdownOptions;
        }
        return dynamicOptions.creditNoteNatureDropdownOptions;
    }, [currentCreditNoteDtl.adjType, dynamicOptions])

    const billToCpyCustomerCodeValidate = useCallback((billToCompanyRcd: string | null, customerCodeRcd: string | null) => {
        let isMatched = true;
        if (creditNoteDetails && creditNoteDetails.length > 0 && editingHeader) {
            // for (const dtl of creditNoteDetails) {
            if (editingHeader.billToCompany !== null && editingHeader.billToCompany !== billToCompanyRcd) {
                isMatched = false;
            }
            if (editingHeader.billToCompany === null && billToCompanyRcd !== null) {
                isMatched = false;
            }
            if (editingHeader.customerCode !== null && editingHeader.customerCode !== customerCodeRcd) {
                isMatched = false;
            }
            if (editingHeader.customerCode === null && customerCodeRcd !== null) {
                isMatched = false;
            }
            if (!isMatched) {
                // messageBarVM.showError("Bill-To company " + billToCompanyRcd === null ? "[]" : billToCompanyRcd
                //     + " and customer code " + customerCodeRcd === null ? "[]" : customerCodeRcd + " does not match with the others details");
                return false;
            }
            // }
        }
        return isMatched;
    }, [creditNoteDetails, editingHeader]);

    const recordValidate = useCallback(() => {
        let billToCompanyRcd = currentCreditNoteHdr.billToCompany;
        let customerCodeRcd = currentCreditNoteHdr.customerCode;
        let selectedCreEntity = EMPTY_CREDIT_NOTE_DETAIL_ENTITY;
        if (selectedcreditNoteDetailRows && selectedcreditNoteDetailRows.length > 0) {
            selectedCreEntity = selectedcreditNoteDetailRows[0];
        }
        if (creditNoteDetails && ((creditNoteDetails.length > 1 && !isAdd)
            || (creditNoteDetails.length > 0 && isAdd))) {
            for (const dtl of creditNoteDetails) {
                let strInvoiceNo = null;
                if (dtl.invoiceNo) {
                    if (dtl.id === selectedCreEntity.id && !isAdd) {
                        strInvoiceNo = dtl.invoiceNo;
                    } else {
                        strInvoiceNo = dtl.invoiceNo;
                    }
                }
                if (strInvoiceNo) {
                    if (!billToCpyCustomerCodeValidate(billToCompanyRcd, customerCodeRcd)) {
                        return false;
                    }
                    break;
                }
            };
        }

        if ((operatingUnit === 'SAPT' || operatingUnit === 'KICT')) {
            if (currentCreditNoteDtl.invoiceNo && currentCreditNoteDtl.oriAmount && currentCreditNoteDtl.creditAmount
                && currentCreditNoteDtl.oriAmount < currentCreditNoteDtl.creditAmount) {
                messageBarVM.showError('Error: ' + currentCreditNoteDtl.invoiceNo + ' Total credit ' + currentCreditNoteDtl.creditAmount
                    + ' greater than original ' + currentCreditNoteDtl.oriAmount + '.');
                return false;
            }

            if (currentCreditNoteDtl.adjType && currentCreditNoteDtl.adjType !== 'Normal' && !currentCreditNoteDtl.creditNoteNature && !currentCreditNoteDtl.invoiceNo) {
                messageBarVM.showError('Credit Note Nature is mandatory.');
                return false;
            }
        }

        let checkCoaHave = false;
        let checkTarHave = false;
        let checkCoa = false;
        let checkTar = false;
        if (currentCreditNoteDtl.tariffType && currentCreditNoteDtl.tariffCode) {
            checkTarHave = true;
        }
        if (!currentCreditNoteDtl.tariffType && !currentCreditNoteDtl.tariffCode) {
            checkTar = true;
        }
        if (currentCreditNoteDtl.revenueAccountCode
            && currentCreditNoteDtl.costCenterCode
            && currentCreditNoteDtl.productServiceCode
            && currentCreditNoteDtl.salesChannelCode
            && currentCreditNoteDtl.projectCode
            && currentCreditNoteDtl.spareCode
            && currentCreditNoteDtl.intercompanyCode) {
            checkCoaHave = true;
        }
        if (!currentCreditNoteDtl.revenueAccountCode
            && !currentCreditNoteDtl.costCenterCode
            && !currentCreditNoteDtl.productServiceCode
            && !currentCreditNoteDtl.salesChannelCode
            && !currentCreditNoteDtl.projectCode
            && !currentCreditNoteDtl.spareCode
            && !currentCreditNoteDtl.intercompanyCode) {
            checkCoa = true;
        }
        if (!((checkTarHave && checkCoaHave) || (checkTarHave && checkCoa) || (checkTar && checkCoaHave))) {
            messageBarVM.showError("[Tar Type,Tar Code] Or [Revenue AC Code,Cost Center Code,Product Service Code,Sales Channel Code,Project Code,Spare Code,Inter Company Code] is mandatory.");
            return false;
        }

        let CHECK_TAX_PERCENTAGE_IND = true;
        let vatTarEmpty = true;
        let vatSoaEmpty = true;
        let vatDtlDesc = true;
        let vatOthers = true;

        if (!currentCreditNoteDtl.invoiceNo
            && (currentCreditNoteDtl.vatTariffType
                || currentCreditNoteDtl.vatTariffCode
                || currentCreditNoteDtl.vatRevenueACCode
                || currentCreditNoteDtl.vatCostCenterCode
                || currentCreditNoteDtl.vatPercent !== null
                || currentCreditNoteDtl.vatSalesChannelCode
                || currentCreditNoteDtl.vatProductServiceCode
                || currentCreditNoteDtl.vatProjectCode
                || currentCreditNoteDtl.vatSpareCode
                || currentCreditNoteDtl.vatDays
                || currentCreditNoteDtl.vatIntercompanyCode
                || currentCreditNoteDtl.vatDateType
                || currentCreditNoteDtl.vatArticleStatementCode
                || (currentCreditNoteDtl.vatDtlDesc1
                    || currentCreditNoteDtl.vatDtlDesc2)
                || currentCreditNoteDtl.taxCode)
            && isNormal) {
            if (!CHECK_TAX_PERCENTAGE_IND) {
                if (!currentCreditNoteDtl.vatTariffType
                    && !currentCreditNoteDtl.vatTariffCode) {
                    vatTarEmpty = false;
                }
            }
            if (currentCreditNoteDtl.vatTariffType
                && currentCreditNoteDtl.vatTariffCode) {
                vatTarEmpty = false;
            }
            if (currentCreditNoteDtl.vatRevenueACCode
                && currentCreditNoteDtl.vatCostCenterCode
                && currentCreditNoteDtl.vatSalesChannelCode
                && currentCreditNoteDtl.vatProductServiceCode
                && currentCreditNoteDtl.vatSpareCode
                && currentCreditNoteDtl.vatIntercompanyCode) {
                vatSoaEmpty = false;
            }
            if (currentCreditNoteDtl.adjType !== 'Normal' || vatSoaEmpty || (!vatSoaEmpty &&
                (currentCreditNoteDtl.vatDtlDesc1
                    || currentCreditNoteDtl.vatDtlDesc2))) {
                vatDtlDesc = false;
            }
            if (!vatTarEmpty &&
                (!currentCreditNoteDtl.vatRevenueACCode
                    && !currentCreditNoteDtl.vatCostCenterCode
                    && !currentCreditNoteDtl.vatSalesChannelCode
                    && !currentCreditNoteDtl.vatProductServiceCode
                    && !currentCreditNoteDtl.vatSpareCode
                    && !currentCreditNoteDtl.vatIntercompanyCode)) {
                vatSoaEmpty = false;
            }
            if (!vatSoaEmpty &&
                !currentCreditNoteDtl.vatTariffType
                && !currentCreditNoteDtl.vatTariffCode) {
                vatTarEmpty = false;
            }
            if (currentCreditNoteDtl.vatDays !== null &&
                currentCreditNoteDtl.vatDateType !== null
                && currentCreditNoteDtl.vatArticleStatementCode !== null
                && currentCreditNoteDtl.taxCode !== null
            ) {
                if (!CHECK_TAX_PERCENTAGE_IND) {
                    vatOthers = false;
                } else {
                    if (currentCreditNoteDtl.vatPercent !== null) {
                        vatOthers = false;
                    }
                }
            }
            if (vatTarEmpty || vatSoaEmpty) {
                messageBarVM.showError("Tax Tariff Type , Tax Tariff Code Or\n Tax Revenue A/C Code,Tax Cost Center Code\n Tax Sales Channel Code,Tax Product Service Code,Tax Project Code,Tax Spare Code,Tax Inter-company Code \n please input them together.");
                return false;
            }
            if (vatOthers) {
                messageBarVM.showError("TAX % , Tax Payment Term , Tax Payment Ref. Date \n Article Statement Code , Tax Code \n please input them together.");
                return false;
            }
            if (vatDtlDesc) {
                messageBarVM.showError("Tax Detail Desc. 1 / Tax Detail Desc. 2 \n please input them together.");
                return false;
            }
        }
        return true;
    }, [currentCreditNoteHdr.billToCompany, currentCreditNoteHdr.customerCode, selectedcreditNoteDetailRows, creditNoteDetails, isAdd, currentCreditNoteDtl.creditAmount, currentCreditNoteDtl.vatPercent, currentCreditNoteDtl.tariffType, currentCreditNoteDtl.tariffCode, currentCreditNoteDtl.revenueAccountCode, currentCreditNoteDtl.costCenterCode, currentCreditNoteDtl.productServiceCode, currentCreditNoteDtl.salesChannelCode, currentCreditNoteDtl.projectCode, currentCreditNoteDtl.spareCode, currentCreditNoteDtl.intercompanyCode, currentCreditNoteDtl.invoiceNo, currentCreditNoteDtl.vatTariffType, currentCreditNoteDtl.vatTariffCode, currentCreditNoteDtl.vatRevenueACCode, currentCreditNoteDtl.vatCostCenterCode, currentCreditNoteDtl.vatSalesChannelCode, currentCreditNoteDtl.vatProductServiceCode, currentCreditNoteDtl.vatProjectCode, currentCreditNoteDtl.vatSpareCode, currentCreditNoteDtl.vatDays, currentCreditNoteDtl.vatIntercompanyCode, currentCreditNoteDtl.vatDateType, currentCreditNoteDtl.vatArticleStatementCode, currentCreditNoteDtl.vatDtlDesc1, currentCreditNoteDtl.vatDtlDesc2, currentCreditNoteDtl.taxCode, currentCreditNoteDtl.oriAmount, currentCreditNoteDtl.adjType, currentCreditNoteDtl.creditNoteNature, operatingUnit, isNormal, billToCpyCustomerCodeValidate, messageBarVM])


    const handleSaveClick = useCallback(async () => {
        setIsLoading(true);
        let skipReqNoValidation = isExistLimit;
        if (operatingUnit === 'SAPT' || operatingUnit === 'KICT') {
            skipReqNoValidation = true;
        }
        const data = await creditNoteDetailVM.onTempSaveDetail(currentCreditNoteHdr, currentCreditNoteDtl, skipReqNoValidation);

        if (data && data["saveCreditNoteFailed"]) {
            // messageBarVM.showError(data["saveCreditNoteFailed"]?.toString());
            setIsLoading(false);
            return;
        }

        if (!recordValidate()) {
            setIsLoading(false);
            return;
        }
        creditNoteDetailVM.onTempSaveClick(currentCreditNoteDtl, isAdd);
        setIsLoading(false);
    }, [isExistLimit, operatingUnit, creditNoteDetailVM, currentCreditNoteHdr, currentCreditNoteDtl, recordValidate, isAdd]);

    const memoTariffCodeOptions = useMemo(() => {
        return currentCreditNoteDtl.tariffType
            ? creditNoteDetailState.dynamicOptions.tariffCodeDropdownOptions[currentCreditNoteDtl.tariffType]
            : [];
    }, [creditNoteDetailState.dynamicOptions.tariffCodeDropdownOptions, currentCreditNoteDtl.tariffType]);

    const memoTaxTariffCodeOptions = useMemo(() => {
        return currentCreditNoteDtl.vatTariffType
            ? creditNoteDetailState.dynamicOptions.taxTariffCodeDropdownOptions[currentCreditNoteDtl.vatTariffType]
            : [];
    }, [creditNoteDetailState.dynamicOptions.taxTariffCodeDropdownOptions, currentCreditNoteDtl.vatTariffType]);

    // useEffect(() => {
    //     const refreshTariffDesc = async () => {

    //         creditNoteDetailVM.onTariffCodeItemChanged(false, countryCode, currentCreditNoteDtl/*.tariffType,currentCreditNoteDtl.tariffCode*/, 'tarDesc');
    //     }
    //     if (!isRead && currentCreditNoteDtl.tariffType && currentCreditNoteDtl.tariffCode) {
    //         refreshTariffDesc();
    //     }

    // }, [currentCreditNoteDtl, creditNoteDetailVM, countryCode, isRead])


    // useEffect(() => {
    //     const refreshVatTariffDesc = async () => {

    //         creditNoteDetailVM.onTariffCodeItemChanged(true, countryCode, currentCreditNoteDtl/*.vatTariffType,currentCreditNoteDtl.vatTariffCode*/, 'vatTariffCodeDesc');
    //     }
    //     if (!isRead && currentCreditNoteDtl.vatTariffType && currentCreditNoteDtl.vatTariffCode) {
    //         refreshVatTariffDesc();
    //     }
    // }, [currentCreditNoteDtl, creditNoteDetailVM, countryCode, isRead])

    useEffect(() => {
        const refreshCreditNoteNatureOptions = async () => {
            if (currentCreditNoteDtl.adjType) {

                creditNoteDetailVM.onAdjTypeItemChanged(currentCreditNoteDtl.adjType);
            }
        }
        if ((!isRead || !isNormal)) {
            refreshCreditNoteNatureOptions();
        }
    }, [currentCreditNoteDtl.adjType, creditNoteDetailVM, isRead, isNormal])

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        creditNoteDetailVM.onFieldChange(fieldName, fieldValue);
    }, [creditNoteDetailVM]);

    const memoState = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.dtlState ?? ''}
                fieldValue={currentCreditNoteDtl?.dtlState}
                fieldLabel={CREDIT_NOTE_CONSTANT.STATE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'dtlState'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.STATE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.dtlState, isSaveClicked])

    const memoInvoiceNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={currentCreditNoteDtl.invoiceNo !== '' || currentCreditNoteDtl.invoiceNo !== null}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.invoiceNo ?? ''}
                fieldValue={currentCreditNoteDtl?.invoiceNo}
                fieldLabel={CREDIT_NOTE_CONSTANT.INVOICE_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'invoiceNo'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.INVOICE_NO, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.invoiceNo, isSaveClicked])

    const memoOriChargingQty = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={CREDIT_NOTE_CONSTANT.ORIG_CHARGING_QTY}
                maxLength={60}
                fieldName={"oriChargingQty"}
                value={currentCreditNoteDtl?.oriChargingQty ?? ''}
                errorMessage={allFormState?.oriChargingQty}
                disabled={true}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.oriChargingQty?.toString() ?? ''}
                fieldValue={currentCreditNoteDtl?.oriChargingQty}
                fieldLabel={CREDIT_NOTE_CONSTANT.ORIG_CHARGING_QTY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'oriChargingQty'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [CREDIT_NOTE_CONSTANT.ORIG_CHARGING_QTY, allFormState, currentCreditNoteDtl?.oriChargingQty, onNumberFieldChange])

    const memoOriAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={CREDIT_NOTE_CONSTANT.ORIG_AMOUNT}
                maxLength={60}
                fieldName={"oriAmount"}
                value={currentCreditNoteDtl?.oriAmount ?? ''}
                errorMessage={allFormState?.oriAmount}
                disabled={true}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.oriAmount?.toString() ?? ''}
                fieldValue={currentCreditNoteDtl?.oriAmount}
                fieldLabel={CREDIT_NOTE_CONSTANT.ORIG_AMOUNT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'oriAmount'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [CREDIT_NOTE_CONSTANT.ORIG_AMOUNT, allFormState, currentCreditNoteDtl?.oriAmount, onNumberFieldChange])

    const memoCreditChargingQty = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={CREDIT_NOTE_CONSTANT.CREDIT_CHARGING_QTY}
                maxLength={10}
                fieldName={"creditChargingQty"}
                value={currentCreditNoteDtl?.creditChargingQty ?? ''}
                errorMessage={allFormState ? allFormState["creditChargingQty"] : ""}
                disabled={isRead}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.creditChargingQty?.toString() ?? ''}
                fieldValue={currentCreditNoteDtl?.creditChargingQty?.toString()}
                fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_CHARGING_QTY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'creditChargingQty'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [CREDIT_NOTE_CONSTANT.CREDIT_CHARGING_QTY, allFormState, currentCreditNoteDtl?.creditChargingQty, isRead, onNumberFieldChange])

    const memoCreditAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={CREDIT_NOTE_CONSTANT.CREDIT_AMOUNT}
                maxLength={13}
                fieldName={"creditAmount"}
                value={currentCreditNoteDtl?.creditAmount ?? ''}
                errorMessage={allFormState?.creditAmount}
                disabled={isRead}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
            errorMessages={allFormState}
            isReadOnly={isRead}
            isShowOptional={true}
            readOnlyValue={currentCreditNoteDtl?.creditAmount?.toString() ?? ''}
            fieldValue={currentCreditNoteDtl?.creditAmount?.toString()}
            fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_AMOUNT}
            isSaveClicked={isSaveClicked}
            fieldType={FieldType.TEXT}
            fieldKey={'creditAmount'}
            maxLength={60}
            requiredFieldList={creditNoteDtlRequiredFieldList}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [CREDIT_NOTE_CONSTANT.CREDIT_AMOUNT, allFormState, currentCreditNoteDtl?.creditAmount, isRead, onNumberFieldChange])

    const memoTarType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.tariffType ?? ''}
                fieldValue={currentCreditNoteDtl?.tariffType}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAR_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                options={creditNoteDetailState.dynamicOptions.tariffTypeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAR_TYPE, allFormState, creditNoteDetailState.dynamicOptions.tariffTypeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.tariffType, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoTarCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.tariffCode ?? ''}
                fieldValue={currentCreditNoteDtl?.tariffCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAR_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCode'}
                options={memoTariffCodeOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onTariffCodeFieldChange(tariffDescMap, currentCreditNoteDtl, fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [tariffDescMap, CREDIT_NOTE_CONSTANT.TAR_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl, isByInvoice, isRead, isReadOnly, isSaveClicked, memoTariffCodeOptions])


    const memoTarDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.tarDesc ?? ''}
                fieldValue={currentCreditNoteDtl?.tarDesc}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAR_DESC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'tarDesc'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAR_DESC, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.tarDesc, isSaveClicked])

    const memoDetailDesc1 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "395px", width: "47.5%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.dtlDesc1 ?? ''}
                fieldValue={currentCreditNoteDtl?.dtlDesc1}
                fieldLabel={CREDIT_NOTE_CONSTANT.DETAIL_DESC1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'dtlDesc1'}
                maxLength={100}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onTextAreaChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)}
            />
        </div>
        , [CREDIT_NOTE_CONSTANT.DETAIL_DESC1, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.dtlDesc1, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoDetailDesc2 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "395px", width: "47.5%", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.dtlDesc2 ?? ''}
                fieldValue={currentCreditNoteDtl?.dtlDesc2}
                fieldLabel={CREDIT_NOTE_CONSTANT.DETAIL_DESC2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'dtlDesc2'}
                maxLength={100}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onTextAreaChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)}
            />
        </div>
        , [CREDIT_NOTE_CONSTANT.DETAIL_DESC2, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.dtlDesc2, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoOpsDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={isRead || isByInvoice || isReadOnly}
                label={CREDIT_NOTE_CONSTANT.OPS_DATE}
                width="250px"
                date={currentCreditNoteDtl?.opsDate}
                fieldName="opsDate"
                errorMessage={allFormState ? allFormState["opsDate"] : ""}
                onDateChange={creditNoteDetailVM.onFieldChange} />
        </div>
        , [isRead, isByInvoice, isReadOnly, CREDIT_NOTE_CONSTANT.OPS_DATE, currentCreditNoteDtl?.opsDate, allFormState, creditNoteDetailVM.onFieldChange])

    const memoAdjType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.adjType ?? ''}
                fieldValue={currentCreditNoteDtl?.adjType}
                fieldLabel={CREDIT_NOTE_CONSTANT.ADJ_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'adjType'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.ADJ_TYPE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.adjType, isSaveClicked])

    const memoCostCenterCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.costCenterCode ?? ''}
                fieldValue={currentCreditNoteDtl?.costCenterCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.COST_CENTER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'costCenterCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.COST_CENTER_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.costCenterCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoProductServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.productServiceCode ?? ''}
                fieldValue={currentCreditNoteDtl?.productServiceCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.PRODUCT_SERVICE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'productServiceCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.PRODUCT_SERVICE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.productServiceCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoSalesChannelCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.salesChannelCode ?? ''}
                fieldValue={currentCreditNoteDtl?.salesChannelCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.SALES_CHANNEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'salesChannelCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.SALES_CHANNEL_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.salesChannelCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoCountryCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.countryCode || countryCode}
                fieldValue={currentCreditNoteDtl?.countryCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.COUNTRY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'countryCode'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.COUNTRY_CODE, allFormState, countryCode, creditNoteDetailVM, currentCreditNoteDtl?.countryCode, isSaveClicked])

    const memoIntercompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.intercompanyCode ?? ''}
                fieldValue={currentCreditNoteDtl?.intercompanyCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.INTER_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'intercompanyCode'}
                options={creditNoteDetailState.dynamicOptions.interCompanyCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.INTER_COMPANY_CODE, allFormState, creditNoteDetailState.dynamicOptions.interCompanyCodeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.intercompanyCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoProjectCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.projectCode ?? ''}
                fieldValue={currentCreditNoteDtl?.projectCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.PROJECT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'projectCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.PROJECT_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.projectCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoSpareCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.spareCode ?? ''}
                fieldValue={currentCreditNoteDtl?.spareCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.SPARE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'spareCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.SPARE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.spareCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.revenueCompanyCode || companyCode}
                fieldValue={currentCreditNoteDtl?.revenueCompanyCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.REVENUE_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueCompanyCode'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.REVENUE_COMPANY_CODE, allFormState, companyCode, creditNoteDetailVM, currentCreditNoteDtl?.revenueCompanyCode, isSaveClicked])

    const memoRevenueAccountCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.revenueAccountCode ?? ''}
                fieldValue={currentCreditNoteDtl?.revenueAccountCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.REVENUE_AC_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'revenueAccountCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.REVENUE_AC_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.revenueAccountCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatPercent = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NumberInputComponent
                label={CREDIT_NOTE_CONSTANT.TAX_PENCENTAGE}
                maxLength={6}
                fieldName={"vatPercent"}
                value={currentCreditNoteDtl?.vatPercent ?? ''}
                errorMessage={allFormState?.vatPercent}
                disabled={isRead || isByInvoice || isReadOnly}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
            {/*<NbisCommonField
            errorMessages={allFormState}
            isReadOnly={isRead || isByInvoice || isReadOnly}
            isShowOptional={true}
            readOnlyValue={currentCreditNoteDtl?.vatPercent?.toString() ?? ''}
            fieldValue={currentCreditNoteDtl?.vatPercent?.toString()}
            fieldLabel={CREDIT_NOTE_CONSTANT.TAX_PENCENTAGE}
            isSaveClicked={isSaveClicked}
            fieldType={FieldType.TEXT}
            fieldKey={'vatPercent'}
            maxLength={200}
            requiredFieldList={creditNoteDtlRequiredFieldList}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => 
                creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_PENCENTAGE, allFormState, currentCreditNoteDtl?.vatPercent, isByInvoice, isRead, isReadOnly, onNumberFieldChange])

    const memoVatRevenueACCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatRevenueACCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatRevenueACCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_REVENUE_AC_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatRevenueACCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_REVENUE_AC_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatRevenueACCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatCostCenterCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatCostCenterCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatCostCenterCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_COST_CENTER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatCostCenterCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_COST_CENTER_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatCostCenterCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatProductServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatProductServiceCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatProductServiceCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_PRODUCT_SERVICE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatProductServiceCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_PRODUCT_SERVICE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatProductServiceCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatSalesChannelCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatSalesChannelCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatSalesChannelCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_SALES_CHANNEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatSalesChannelCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_SALES_CHANNEL_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatSalesChannelCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatCountryCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatCountryCode || countryCode}
                fieldValue={currentCreditNoteDtl?.vatCountryCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_COUNTRY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatCountryCode'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_COUNTRY_CODE, allFormState, countryCode, creditNoteDetailVM, currentCreditNoteDtl?.vatCountryCode, isSaveClicked])

    const memoVatIntercompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatIntercompanyCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatIntercompanyCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_INTER_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatIntercompanyCode'}
                options={creditNoteDetailState.dynamicOptions.taxInterCompanyCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_INTER_COMPANY_CODE, allFormState, creditNoteDetailState.dynamicOptions.taxInterCompanyCodeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.vatIntercompanyCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatProjectCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatProjectCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatProjectCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_PROJECT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatProjectCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_PROJECT_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatProjectCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatSpareCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatSpareCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatSpareCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_SPARE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatSpareCode'}
                maxLength={25}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_SPARE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatSpareCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatCompanyCode || companyCode}
                fieldValue={currentCreditNoteDtl?.vatCompanyCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatCompanyCode'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_COMPANY_CODE, allFormState, companyCode, creditNoteDetailVM, currentCreditNoteDtl?.vatCompanyCode, isSaveClicked])

    const memoVatTransactionType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatTransactionType || ""}
                fieldValue={currentCreditNoteDtl?.vatTransactionType}
                fieldLabel={CREDIT_NOTE_CONSTANT.TRANSACTION_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatTransactionType'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TRANSACTION_TYPE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatTransactionType, isSaveClicked])

    const memoVatDays = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatDays?.toString() ?? ''}
                fieldValue={currentCreditNoteDtl?.vatDays?.toString()}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_PAYMENT_TERM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDays'}
                maxLength={10}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_PAYMENT_TERM, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatDays, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatArticleStatement = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatArticleStatement || ""}
                fieldValue={currentCreditNoteDtl?.vatArticleStatement}
                fieldLabel={CREDIT_NOTE_CONSTANT.ARTICLE_STATEMENT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatArticleStatement'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.ARTICLE_STATEMENT, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatArticleStatement, isSaveClicked])

    const memoVatDtlDesc1 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatDtlDesc1 ?? ''}
                fieldValue={currentCreditNoteDtl?.vatDtlDesc1}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_DETAIL_DESC1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDtlDesc1'}
                maxLength={100}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_DETAIL_DESC1, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatDtlDesc1, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatDtlDesc2 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatDtlDesc2 ?? ''}
                fieldValue={currentCreditNoteDtl?.vatDtlDesc2}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_DETAIL_DESC2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatDtlDesc2'}
                maxLength={100}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_DETAIL_DESC2, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatDtlDesc2, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoTaxCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.taxCode ?? ''}
                fieldValue={currentCreditNoteDtl?.taxCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'taxCode'}
                options={creditNoteDetailState.dynamicOptions.taxCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_CODE, allFormState, creditNoteDetailState.dynamicOptions.taxCodeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.taxCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatDateType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatDateType ?? ''}
                fieldValue={currentCreditNoteDtl?.vatDateType}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_PAYMENT_REFERENCE_DATE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatDateType'}
                options={vatPaymentReferenceDateDropdownOption}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_PAYMENT_REFERENCE_DATE, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatDateType, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatTariffType ?? ''}
                fieldValue={currentCreditNoteDtl?.vatTariffType}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatTariffType'}
                options={creditNoteDetailState.dynamicOptions.taxTariffTypeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_TARIFF_TYPE, allFormState, creditNoteDetailState.dynamicOptions.taxTariffTypeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.vatTariffType, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoVatTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatTariffCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatTariffCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_TARIFF_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatTariffCode'}
                options={memoTaxTariffCodeOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onVatTariffCodeFieldChange(tariffDescMap, currentCreditNoteDtl, fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_TARIFF_CODE, allFormState, creditNoteDetailVM, currentCreditNoteDtl, isByInvoice, isRead, isReadOnly, isSaveClicked, memoTaxTariffCodeOptions, tariffDescMap])

    const memoVatTariffCodeDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatTariffCodeDesc || ""}
                fieldValue={currentCreditNoteDtl?.vatTariffCodeDesc}
                fieldLabel={CREDIT_NOTE_CONSTANT.TAX_TARIFF_CODE_DESC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vatTariffCodeDesc'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TAX_TARIFF_CODE_DESC, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.vatTariffCodeDesc, isSaveClicked])

    const memoVatArticleStatementCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.vatArticleStatementCode ?? ''}
                fieldValue={currentCreditNoteDtl?.vatArticleStatementCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.ARTICLE_STATEMENT_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vatArticleStatementCode'}
                options={creditNoteDetailState.dynamicOptions.articleStatementCodeDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.ARTICLE_STATEMENT_CODE, allFormState, creditNoteDetailState.dynamicOptions.articleStatementCodeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.vatArticleStatementCode, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoCreditNoteNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.creditNoteNo || ""}
                fieldValue={currentCreditNoteDtl?.creditNoteNo}
                fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_NOTE_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'creditNoteNo'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CREDIT_NOTE_NO, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.creditNoteNo, isSaveClicked])

    const memoChargeInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead || isByInvoice || isReadOnly}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.chargeInd ?? ''}
                fieldValue={currentCreditNoteDtl?.chargeInd}
                fieldLabel={CREDIT_NOTE_CONSTANT.CHARGE_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeInd'}
                options={creditNoteDetailState.dynamicOptions.chargeIndDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CHARGE_IND, allFormState, creditNoteDetailState.dynamicOptions.chargeIndDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.chargeInd, isByInvoice, isRead, isReadOnly, isSaveClicked])

    const memoCreditNoteNature = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={(isRead && isNormal) || isByInvoice || isReadOnly}
                isShowOptional={isNormal || (operatingUnit !== 'SAPT' && operatingUnit !== 'KICT')}
                readOnlyValue={currentCreditNoteDtl?.creditNoteNature ?? ''}
                fieldValue={currentCreditNoteDtl?.creditNoteNature}
                fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_NOTE_NATURE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'creditNoteNature'}
                options={creditNoteNatureOptions()}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, isNormal, isByInvoice, isReadOnly, operatingUnit, currentCreditNoteDtl?.creditNoteNature, CREDIT_NOTE_CONSTANT.CREDIT_NOTE_NATURE, isSaveClicked, creditNoteNatureOptions, creditNoteDetailVM])

    const memoExceptionMsg = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.exceptionMsg || ""}
                fieldValue={currentCreditNoteDtl?.exceptionMsg}
                fieldLabel={CREDIT_NOTE_CONSTANT.EXCEPTION_MSG}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'exceptionMsg'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.EXCEPTION_MSG, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.exceptionMsg, isSaveClicked])

    const memoCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentCreditNoteDtl?.currencyCode ?? ''}
                fieldValue={currentCreditNoteDtl?.currencyCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'currencyCode'}
                options={creditNoteDetailState.dynamicOptions.currencyCodeDropdownOptions}
                maxLength={60}
                errorMessage={allFormState ? allFormState["currencyCode"] : ""}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CURRENCY, allFormState, creditNoteDetailState.dynamicOptions.currencyCodeDropdownOptions, creditNoteDetailVM, currentCreditNoteDtl?.currencyCode, isRead, isSaveClicked])

    const memoTotalAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.totalAmount?.toString() || ""}
                fieldValue={currentCreditNoteDtl?.totalAmount}
                fieldLabel={CREDIT_NOTE_CONSTANT.TOTAL_AMOUNT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'exceptionMsg'}
                maxLength={60}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.TOTAL_AMOUNT, allFormState, creditNoteDetailVM, currentCreditNoteDtl?.totalAmount, isSaveClicked])
    // const handleEdit = useCallback(() => {
    //     creditNoteDetailVM.onDetailEdit();
    // }, [creditNoteDetailVM]);

    const memoPOO = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.poo ?? ''}
                fieldValue={currentCreditNoteDtl?.poo}
                fieldLabel={CREDIT_NOTE_CONSTANT.POO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'poo'}
                isShowMissingError={false}
                maxLength={5}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChangeUpperCase(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.POO, allFormState, currentCreditNoteDtl?.poo, isRead, isSaveClicked, creditNoteDetailVM])

    const memoPOOInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.pooInd ?? ''}
                fieldValue={currentCreditNoteDtl?.pooInd}
                fieldLabel={CREDIT_NOTE_CONSTANT.POO_GEOG_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'pooInd'}
                isShowMissingError={false}
                maxLength={2}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [CREDIT_NOTE_CONSTANT.POO_GEOG_IND, currentCreditNoteDtl?.pooInd, isSaveClicked])

    const memoPOD = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.pod ?? ''}
                fieldValue={currentCreditNoteDtl?.pod}
                fieldLabel={CREDIT_NOTE_CONSTANT.POD}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'pod'}
                isShowMissingError={false}
                maxLength={5}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChangeUpperCase(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.POD, allFormState, currentCreditNoteDtl?.pod, isRead, isSaveClicked, creditNoteDetailVM])

    const memoPODInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.podInd ?? ''}
                fieldValue={currentCreditNoteDtl?.podInd}
                fieldLabel={CREDIT_NOTE_CONSTANT.POD_GEOG_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'podInd'}
                isShowMissingError={false}
                maxLength={2}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [CREDIT_NOTE_CONSTANT.POD_GEOG_IND, currentCreditNoteDtl?.podInd, isSaveClicked])

    const memoFD = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.fd ?? ''}
                fieldValue={currentCreditNoteDtl?.fd}
                fieldLabel={CREDIT_NOTE_CONSTANT.FD}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'fd'}
                isShowMissingError={false}
                maxLength={5}
                requiredFieldList={creditNoteDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onFieldChangeUpperCase(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.FD, allFormState, currentCreditNoteDtl?.fd, isRead, isSaveClicked, creditNoteDetailVM])

    const memoFDInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "250px", maxWidth: "250px", width: "30%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteDtl?.fdInd ?? ''}
                fieldValue={currentCreditNoteDtl?.fdInd}
                fieldLabel={CREDIT_NOTE_CONSTANT.FD_GEOG_IND}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'fdInd'}
                isShowMissingError={false}
                maxLength={2}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [CREDIT_NOTE_CONSTANT.FD_GEOG_IND, currentCreditNoteDtl?.fdInd, isSaveClicked])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    {/* <Sidebarheader style={{width: '100%'}}>
                <SidebarTitle>{'Detail'}</SidebarTitle>
                    <SidebarActionCross>
                        {(!isAdd && (isEditable && isRead)) &&
                            <>
                                {
                                    (
                                        (isEditable)
                                    )
                                    && <IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                                }
                            </>}
                            <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={handleCancelClick} />
                        {((isAdd || (isEditable && !isRead))) &&
                            <>
                                {
                                    (
                                        (isAdd) ||
                                        (isEditable && !isRead)
                                    )
                                    && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSaveClick()} />
                                }
                            </>}
                    </SidebarActionCross>

                </Sidebarheader> */}

                    <Sidebarheader>
                        <SidebarTitle>{'Detail'}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Large" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoState}
                            {memoOriChargingQty}
                            {memoOriAmount}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {!isByManual && memoInvoiceNo}
                            {memoAdjType}
                            {memoCountryCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCreditChargingQty}
                            {memoCreditAmount}
                            {memoTotalAmount}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoTarType}
                            {memoTarCode}
                            {memoTarDesc}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoDetailDesc1}
                            {memoDetailDesc2}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoOpsDate}
                            {memoChargeInd}
                            {memoCreditNoteNo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoRevenueAccountCode}
                            {memoCostCenterCode}
                            {memoProductServiceCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSalesChannelCode}
                            {memoIntercompanyCode}
                            {memoProjectCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSpareCode}
                            {memoCompanyCode}
                            {memoVatPercent}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatRevenueACCode}
                            {memoVatCostCenterCode}
                            {memoVatProductServiceCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatIntercompanyCode}
                            {memoVatSalesChannelCode}
                            {memoVatProjectCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatSpareCode}
                            {memoVatArticleStatement}
                            {memoVatArticleStatementCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCreditNoteNature}
                            {memoTaxCode}
                            {memoCurrency}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatTariffType}
                            {memoVatTariffCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatTariffCodeDesc}
                            {memoVatDays}
                            {memoVatDateType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatCountryCode}
                            {memoVatCompanyCode}
                            {memoVatTransactionType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoVatDtlDesc1}
                            {memoVatDtlDesc2}
                            {memoExceptionMsg}
                        </CriteriaItemContainer>
                        {operatingUnit !== "SAPT" &&
                            operatingUnit !== "KICT" &&
                            <CriteriaItemContainer>
                                {memoPOO}
                                {memoPOOInd}
                                {memoPOD}
                            </CriteriaItemContainer>}

                        {operatingUnit !== "SAPT" &&
                            operatingUnit !== "KICT" &&
                            <CriteriaItemContainer>
                                {memoPODInd}
                                {memoFD}
                                {memoFDInd}
                            </CriteriaItemContainer>}

                    </div>
                    {creditNoteDetailState.forceRefresh && <></>}
                </div>
            </div>
            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={handleCancelClick} />
                        {(!isRead || !isNormal) && <HPHButton label={isAdd ? 'Add' : isEditable ? 'Update' : 'Save'} size={'Small'} theme={'Primary'} onClick={handleSaveClick} />}
                    </>
                }
            </div>
        </div>
    )
}